import React from 'react';
import { useData } from '../context/DataContext';
import styles from '../styles/components/Citations.module.css';
import cardStyles from '../styles/components/Card.module.css';

function Citations() {
  const { dataSources, lastUpdated, loading, error } = useData();

  const handleSocialClick = (platform) => {
    if (window.gtag) {
      window.gtag('event', 'social_link_click', {
        'event_category': 'Social',
        'event_label': platform
      });
    }
  };

  if (loading || error || !dataSources) return null;

  return (
    <section className={styles.citations}>
      <h2>Data Sources</h2>
      <div className={styles.sourceList}>
        <div className={`${cardStyles.exploitationCard} ${styles.source}`}>
          <h3 className={cardStyles.header}>Wealth Inequality Data</h3>
          <div className={cardStyles.content}>
            <p>Source: {dataSources.wealthInequality}</p>
            <a href="https://fred.stlouisfed.org/" target="_blank" rel="noopener noreferrer">
              Federal Reserve Economic Data (FRED)
            </a>
          </div>
        </div>
        
        <div className={`${cardStyles.exploitationCard} ${styles.source}`}>
          <h3 className={cardStyles.header}>Billionaire Data</h3>
          <div className={cardStyles.content}>
            <p>Source: {dataSources.billionaires}</p>
            <a href="https://www.forbes.com/real-time-billionaires/" target="_blank" rel="noopener noreferrer">
              Forbes Real-Time Billionaires
            </a>
          </div>
        </div>

        <div className={`${cardStyles.exploitationCard} ${styles.source}`}>
          <h3 className={cardStyles.header}>Labor Market Data</h3>
          <div className={cardStyles.content}>
            <p>Sources:</p>
            <ul>
              <li>Productivity: {dataSources.productivity}</li>
              <li>Corporate Profits: {dataSources.corporateProfits}</li>
              <li>Minimum Wage: {dataSources.minimumWage}</li>
              <li>Median Household Income: {dataSources.medianHouseholdIncome}</li>
            </ul>
            <a href="https://fred.stlouisfed.org/" target="_blank" rel="noopener noreferrer">
              Federal Reserve Economic Data (FRED)
            </a>
          </div>
        </div>
      </div>
      
      <p className={styles.lastUpdated}>
        Last updated: {new Date(lastUpdated).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })}
      </p>
      <div className={styles.copyright}>
        <p>© {new Date().getFullYear()} <a href="https://blackpaw.studio" target="_blank" rel="noopener noreferrer" onClick={() => handleSocialClick('blackpaw_studio')}>Blackpaw Studio</a>. All Rights Reserved.</p>
        <div className={styles.socialLinks}>
          <a href="https://bsky.app/profile/edc.me" target="_blank" rel="noopener noreferrer" title="Follow on Bluesky" onClick={() => handleSocialClick('bluesky')}>@edc.me on Bluesky</a>
          <a href="https://coleman.social/@evan" target="_blank" rel="noopener noreferrer" title="Follow on Mastodon" onClick={() => handleSocialClick('mastodon')}>@evan@coleman.social</a>
        </div>
      </div>
    </section>
  );
}

export default Citations; 